import type { TalentMemberDto } from "@fp/admin-api-client/types/talentMemberDto.js";
import type { ReactNode } from "react";
import { FormattedPhone } from "@/components/base/text/formatted-phone";
import { PayoutSetupStatusBadge } from "./payout-setup-status-badge";
import { IdentityVerificationEntityBadge } from "./identity-verification-entity-badge";

interface TalentMemberRowProps {
  talent: TalentMemberDto;
  actions?: ReactNode;
}

export const TalentMemberRow = ({
  talent,
  actions,
}: TalentMemberRowProps) => {
  return (
    <>
      <div className="flex items-center flex-1 min-w-0">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 min-w-0">
            <p className="truncate text-sm font-semibold text-gray-700">
              {talent.firstName && talent.lastName
                ? `${talent.lastName}, ${talent.firstName}`
                : talent.firstName || talent.lastName || talent.email}
            </p>
            <div className="flex items-center gap-2 shrink-0">
              <PayoutSetupStatusBadge status={talent.payoutSetupStatus} />
              <IdentityVerificationEntityBadge
                entityType={talent.identityVerificationEntityType}
                businessName={talent.identityVerificationBusinessName}
              />
            </div>
          </div>
          <div className="text-sm text-gray-600">
            <FormattedPhone value={talent.phone} />
          </div>
        </div>
      </div>
      {actions}
    </>
  );
};
